import { Link } from "react-router-dom";

export const LogoMark = ({ size = 36, className = "" }) => (
  <svg width={size * 2.5} height={size} viewBox="0 0 120 48" fill="none" className={className} aria-label="GM7" preserveAspectRatio="xMidYMid meet">
    <defs>
      <linearGradient id="gm7-wordmark-gold" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#F5E29E" />
        <stop offset="0.45" stopColor="#D9B44A" />
        <stop offset="1" stopColor="#8F6D14" />
      </linearGradient>
    </defs>
    <text x="60" y="39" textAnchor="middle" fontFamily="Georgia, 'Times New Roman', serif" fontWeight="700" fontSize="42" letterSpacing="1" fill="url(#gm7-wordmark-gold)">GM7</text>
  </svg>
);

export default function Logo({ compact = false }) {
  return (
    <Link to="/" className="flex items-center gap-3" data-testid="logo-home-link">
      <LogoMark size={34} />
      {!compact && (
        <div className="text-right leading-tight border-r border-gold/25 pr-3">
          <div className="font-display text-lg font-extrabold text-slate-50">
            گروه وکلای مهاجرت <span className="gold-text">۷</span>
          </div>
          <div className="text-[9px] font-bold tracking-[0.32em] text-gold/70">IMMIGRATION LAW GROUP</div>
        </div>
      )}
    </Link>
  );
}

